<template>
  <div class="raffle" id="raffle">
    <div class="top">
      <div class="lottery-block">
        <div class="lottery-box">
          <div class="lottery-item" v-for="(one, i) in imgList" :key="i" @click="start(i)">
            <img :class="index == one.num ? 'active' : ''" :src="one.url" />
          </div>
        </div>
      </div>
    </div>
    <div class="reward">
      <img :src="rewardUlr" />
      <div class="reward-word" v-if="rewardNum != 4">{{ rewardWordObj[rewardNum] }}</div>
      <div class="remind-word" v-if="rewardNum != 0 && rewardNum != 4">*奖品需购机后领取，官方电话：0731-86407968</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "raffle",
  components: {},
  data() {
    return {
      imgList: [
        {
          num: 1,
          prizeRank: 4,
          url: "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-thanks.png",
        },
        {
          num: 2,
          prizeRank: 1,
          url: "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-reward1.png",
        },
        {
          num: 3,
          prizeRank: 4,
          url: "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-thanks.png",
        },
        {
          num: 8,
          prizeRank: 3,
          url: "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-reward3.png",
        },
        {
          num: 10,
          url: "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/clue/raffle-bg6.png",
        },
        {
          num: 4,
          prizeRank: 3,
          url: "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-reward3.png",
        },
        {
          num: 7,
          prizeRank: 4,
          url: "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-thanks.png",
        },
        {
          num: 6,
          prizeRank: 2,
          url: "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-reward2.png",
        },
        {
          num: 5,
          prizeRank: 4,
          url: "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-thanks.png",
        },
      ],
      rewardWordObj: {
        0: "您还未获得奖品",
        1: "三一485遥控挖掘机模型",
        2: "三一起重机积木套装",
        3: "三一定制金挖斗烟灰缸",
        4: "谢谢参与",
      },
      endpointObj: {
        1: 2,
        2: 6,
        3: 4,
        4: 7,
      },
      userPhone: "",
      rewardNum: 0,
      rewardUlr: `https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/gift2-reward0.png`,
      canClick: true,
      t: null, //定时器
      circles: 1, //所需圈数
      currentcircles: 1, //记录当前是第几圈
      speed: 1, //转动的速度
      endpoint: 1, //最后停止的位置，即选中了谁
      index: 0, //记录当前循环的次数
    };
  },
  created() {
    document.title = "买二手设备上云联二手机";
    let params = this.$route.query;
    this.userPhone = params.userPhone;
    // this.getLotteryHistory();
  },
  mounted() {
    document.getElementById("raffle").scrollIntoView(true);
  },
  methods: {
    // getLotteryHistory() {
    //   this.$api.getGiftHistory({ phone: this.userPhone, lotteryActivityId: 2 }).then((res) => {
    //     if (res.data.code == 0) {
    //       if (res.data.data.length == 1 && this.userPhone) {
    //         this.rewardNum = res.data.data[0].prizeRank || 0;
    //       }
    //     }
    //   });
    // },
    start(i) {
      if (i != 4) return;
      if (this.rewardNum != 0) return;
      if (!this.canClick) return;
      this.canClick = false;
      this.circles = 5;
      this.currentcircles = 1; //当前的圈数
      this.speed = 700; //频率
      this.$api.getGift({ phone: this.userPhone, lotteryActivityId: 2 }).then((res) => {
        if (res.data.code == 0) {
          this.index = 1;
          this.endpoint = res.data.data[0].prizeRank; //中奖号
          this.t = setInterval(this.highTurn, this.speed); //循环奖品方法
        } else {
          this.canClick = true;
        }
      });
    },
    highTurn() {
      if (this.index % 8 == 0) {
        this.currentcircles++; //进入下一圈当前圈数+1
        this.index = 0;
      }
      this.index++; //然后循环次数+1，不要把它放到圈数加1的前面去
      //这里用来改变速度，第一圈是每经过一个奖品则速度+80，setInterval的第二个参数是多长时间执行一次，值越小，执行的频率越高
      if (this.currentcircles == 1) {
        window.clearInterval(this.t);
        this.speed -= 80; //第一圈开始加速
        this.t = setInterval(this.highTurn, this.speed);
      } else if (this.currentcircles == this.circles) {
        window.clearInterval(this.t);
        this.speed += 80; //最后一圈开始减速
        this.t = setInterval(this.highTurn, this.speed);
      }
      //如果当前圈数等于要循环的圈数，且当前循环到的奖品编号等于终结点则判定为循环结束，最终会停在终点位置的奖品上
      if (this.circles == this.currentcircles && this.index % 8 == this.endpointObj[this.endpoint]) {
        window.clearInterval(this.t); //清除setInterval
        this.t = null; //清除定时器
        setTimeout(() => {
          this.canClick = true;
          this.index = 0;
          this.rewardNum = this.endpoint;
          this.$toast({ message: this.rewardWordObj[this.endpoint], position: "bottom" });
          return;
        }, 10);
      }
    },
  },
  watch: {
    rewardNum(val) {
      this.rewardUlr = `https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/${val == 4 ? "gift2-thanks" : "gift2-reward" + val}.png`;
      if (val == 0) {
        this.imgList[4].url = "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/clue/raffle-bg6.png";
      } else {
        this.imgList[4].url = "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/clue/raffle-bg7.png";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.raffle {
  width: 375px;
  height: 100%;
  background-color: #ff0000;
  .top {
    background: url("https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/clue/raffle-bg1.png") no-repeat;
    background-size: 375px 529px;
    padding-top: 280px;
    .lottery-block {
      width: 341px;
      margin: 0 auto;
      background: url("https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/clue/raffle-bg5.png");
      background-repeat: no-repeat;
      background-size: contain;
      padding: 18px 17px;
      box-sizing: border-box;
      .lottery-box {
        width: 100%;
        overflow: hidden;
        .lottery-item {
          width: 33.33%;
          float: left;
          text-align: center;
          box-sizing: border-box;
          padding: 7px;
          img {
            display: block;
            width: 100%;
            height: auto;
          }
          .active {
            box-sizing: border-box;
            border: 3px solid rgba(251, 70, 63, 1);
            border-radius: 10px;
          }
        }
      }
    }
  }
  .reward {
    width: 100%;
    height: 450px;
    background: url("https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/clue/raffle-bg4.png");
    background-repeat: no-repeat;
    background-size: contain;
    text-align: center;
    margin-top: 7px;
    img {
      width: 121px;
      margin-top: 58px;
    }
    .reward-word {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 16px;
      margin-top: 8px;
    }
    .remind-word {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ed3400;
      line-height: 14px;
      margin-top: 6px;
    }
  }
}
</style>
